import type { Site } from '@datadog/browser-core'
import z from 'zod'
import { isObject } from '~/helpers/type-guards'
import packageJson from '../../package.json'
import { getEnvVarNumber } from '~/config/environment'

export type DatadogClientConfig = {
  applicationId: string
  clientToken: string
  site: Site
  version: string
  service: string
  sessionSampleRate: number
  sessionReplaySampleRate: number
  telemetryConfigurationSampleRate: number
  telemetryUsageSampleRate: number
  telemetrySampleRate: number
  traceSampleRate: number
}

export const getDatadogClientConfig = (): DatadogClientConfig => {
  return {
    applicationId: process.env.DATADOG_APPLICATION_ID || '',
    clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
    site: 'datadoghq.eu',
    version: packageJson.version,
    service: 'client-area-frontend',
    sessionSampleRate: getEnvVarNumber('DATADOG_SESSION_SAMPLE_RATE', 30),
    sessionReplaySampleRate: getEnvVarNumber('DATADOG_SESSION_REPLAY_SAMPLE_RATE', 0),
    traceSampleRate: getEnvVarNumber('DATADOG_TRACE_SAMPLE_RATE', 30),
    telemetryConfigurationSampleRate: getEnvVarNumber('DATADOG_TELEMETRY_CONFIGURATION_SAMPLE_RATE', 5),
    telemetryUsageSampleRate: getEnvVarNumber('DATADOG_TELEMETRY_USAGE_SAMPLE_RATE', 5),
    telemetrySampleRate: getEnvVarNumber('DATADOG_TELEMETRY_SAMPLE_RATE', 20),
  }
}

export const isDatadogClientConfig = (config: any): config is DatadogClientConfig => {
  return isObject<DatadogClientConfig>(
    config,
    z.object({
      applicationId: z.string().nonempty(),
      clientToken: z.string().nonempty(),
      site: z.custom<Site>((val) => typeof val === 'string' && val.length > 0),
      version: z.string().nonempty(),
      service: z.string().nonempty(),
      sessionSampleRate: z.number().min(0).max(100),
      sessionReplaySampleRate: z.number().min(0).max(100),
      traceSampleRate: z.number().min(0).max(100),
      telemetryConfigurationSampleRate: z.number().min(0).max(100),
      telemetryUsageSampleRate: z.number().min(0).max(100),
      telemetrySampleRate: z.number().min(0).max(100),
    }),
  )
}

export type DatadogServerConfig = {
  version: string
  service: string
  agentUrl: string
}

export const getDatadogServerConfig = (): DatadogServerConfig => {
  return {
    version: packageJson.version || '1.0.0',
    service: 'client-area-server',
    agentUrl: process.env.DATADOG_AGENT_URL || '',
  }
}
